import { getMe } from '~/api/agent';
import { getUserPoin } from '~/api/agent-retention';

export const state = () => ({
  me: {},
  userTier: [],
  isLoadingTier: false,
});

export const getters = {
  getMe: state => state.me || {},
  getUserTier: state => state.userTier || [],
  getIsLoadingTier: state => state.isLoadingTier || false,
};

export const mutations = {
  setMe(state, data) {
    state.me = data;
  },
  setUserTier(state, data) {
    state.userTier = [...state.userTier, data];
  },
  setIsLoadingTier(state, data) {
    state.isLoadingTier = data;
  },
};

export const actions = {
  async getMe({ commit }) {
    try {
      const response = await getMe(this.$axios);
      if (response.meta.http_status === 200) commit('setMe', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },

  async getCurrentUserTier({ commit, dispatch, rootState }) {
    try {
      if (!rootState?.user?.me?.id) {
        commit('setUserTier', 'livechat_info__mitra_non_user');
        return;
      }
      const responseAgentMe = await dispatch('getMe');
      if (!responseAgentMe) {
        commit('setUserTier', 'livechat_info__mitra_non_user');
        return;
      }
      const { data: agentMe } = responseAgentMe;
      const { data: userPoint } = await getUserPoin(this.$axios);

      if (userPoint?.loyalty_tier) {
        commit('setUserTier', `mitra_tier_${userPoint?.loyalty_tier.toLowerCase()}`);
      }

      const isFirstInteraction = agentMe?.onboarding_step?.first_transaction;
      const isVipTier =
        userPoint?.loyalty_tier?.toLowerCase() === 'platinum' ||
        userPoint?.loyalty_tier?.toLowerCase() === 'gold' ||
        false;

      if (isVipTier) {
        commit('setUserTier', 'livechat_info__mitra__tier_vip');
      } else if (!isFirstInteraction && !isVipTier) {
        commit('setUserTier', 'livechat_info__mitra__new');
      } else if (isFirstInteraction && !isVipTier) {
        commit('setUserTier', 'livechat_info__mitra__normal');
      }
      return { agentMe, userPoint };
    } catch (error) {
      // handle error
    } finally {
      commit('setIsLoadingTier', false);
    }
  },
};
